import { WorkOrderTriggerKind } from "@redotech/redo-model/work-order-flow/work-order-flow";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const createWorkOrderFlow = {
  name: "createWorkOrderFlow" as const,
  input: z.object({
    name: z.string().min(1),
    triggerKind: createEnum(WorkOrderTriggerKind),
  }),
  output: z.object({ id: z.string() }),
};
